<template>
  <v-container v-if="filter">
    <report
      title="Recognition Report"
      :filter="filter"
      :team="team"
      :manager="manager"
      :user="user"
      v-on:refreshData="refreshData"
      v-on:rowClick="rowClick"
      :headers="headers"
      :loading="list_loading"
      :items="items"
      :show-table="!filter.userId"
    >
      <v-card-text class="py-0">
        <loading-spinner v-if="trend_loading"> </loading-spinner>
        <trend-chart
          v-else
          :loading="trend_loading"
          :height="250"
          y-axes-fluid
          count
          tooltip-append=" recognitions"
          round
        ></trend-chart>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <v-row>
          <v-col v-if="filter.userId" cols="12" sm="3" class="pr-0">
            <v-row>
              <v-col cols="12" class="pl-8">
                <div class="secondary--text font-weight-medium subtitle-1">
                  Has been recognized
                </div>
                <div>
                  {{ item.recognized }}
                </div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="12" class="pl-8">
                <div class="secondary--text font-weight-medium subtitle-1">
                  Has recognized others
                </div>
                <div>
                  {{ item.recognizedOthers }}
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-divider v-if="filter.userId" vertical></v-divider>
          <v-col cols="12" :sm="filter.userId ? 9 : 12" class="my-auto mr-n1">
            <recognition-badges
              :core-values="recognition.coreValues"
              :size="70"
            ></recognition-badges>
          </v-col>
        </v-row>
        <v-tabs v-model="tab" v-if="!filter.userId">
          <v-tab :class="{ 'd-none': filter.managerId }">
            Departments
          </v-tab>
          <v-tab
            :class="{
              'd-none':
                filter.managerId ||
                (recognition.overview && recognition.overview.hideManagers) ||
                !settings.showManagers
            }"
          >
            Teams
          </v-tab>
          <v-tab>
            Members
          </v-tab>
        </v-tabs>
      </v-card-text>
    </report>
    <v-row v-masonry v-if="ordered_recognitions">
      <v-col
        v-masonry-tile
        cols="12"
        sm="6"
        lg="4"
        v-for="item in ordered_recognitions"
        :key="item.id"
      >
        <recognition-card :recognition="item"> </recognition-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Report from "@/components/reporting/Report";
import { mapGetters } from "vuex";
import TrendChart from "@/components/reporting/TrendChart";
import RecognitionCard from "@/components/recognition/RecognitionCard";
import RecognitionBadges from "@/components/recognition/RecognitionBadges";
import reports from "@/helpers/mixins/reports";
export default {
  name: "RecognitionReport",
  props: {
    filter: { type: Object },
    team: { type: Object },
    manager: { type: Object },
    user: { type: Object }
  },
  components: {
    TrendChart,
    RecognitionCard,
    RecognitionBadges,
    Report
  },
  mixins: [reports],
  data: () => ({
    list_loading: false,
    trend_loading: false,
    tab: 0,
    headers: [
      { text: "Name", value: "name" },
      { text: "Has recognized others", value: "recognizedOthers" },
      { text: "Has been recognized", value: "recognized" },
      { text: "", value: "actions" }
    ]
  }),
  watch: {
    tab(val, oldVal) {
      if (val != oldVal) {
        this.getList();
      }
    },
    filter(val, oldVal) {
      if (!oldVal && val != null) {
        this.update();
      }
    }
  },
  computed: {
    ordered_recognitions() {
      if (!this.recognition.recognitions) {
        return null;
      }
      return this._.orderBy(
        this.recognition.recognitions,
        ["createdDate"],
        ["desc"]
      );
    },
    items() {
      let data = [];
      switch (this.tab) {
        case 0:
          data = this.recognition.teams;
          break;
        case 1:
          data = this.recognition.managers;
          break;
        case 2:
          data = this.recognition.members;
          break;
      }
      if (this.filter.userId) {
        data = this.recognition.member;
      }
      return data || [];
    },
    item() {
      return this.recognition.member || {};
    },
    ...mapGetters({
      recognition: "reporting/recognition",
      settings: "profile/settings"
    })
  },
  created() {
    if (this.filter != null) {
      this.update();
    }
  },
  methods: {
    rowClick(item) {
      let link = this.getLink(item);
      if (!link) {
        return;
      }
      this.$router.push({ path: link });
    },
    update() {
      this.refreshData();
    },
    getList() {
      this.list_loading = true;
      Promise.all([this.$store.dispatch(this.getAction(), this.filter)])
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading report."
          );
        })
        .finally(() => {
          this.list_loading = false;
        });
    },
    getAction() {
      if (this.filter.userId) {
        return "reporting/getRecognitionMember";
      }
      switch (this.tab) {
        case 0:
          return "reporting/getRecognitionTeams";
        case 1:
          return "reporting/getRecognitionManagers";
        default:
          return "reporting/getRecognitionMembers";
      }
    },
    refreshData() {
      this.$store.dispatch("reporting/clearRecognition").then(() => {
        this.list_loading = true;
        this.trend_loading = true;
        Promise.all([
          this.$store.dispatch("reporting/getRecognitionTrend", this.filter),
          this.$store.dispatch("reporting/getRecognition", this.filter)
        ])
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occured while loading report."
            );
          })
          .finally(() => {
            this.list_loading = false;
            this.trend_loading = false;
          })
          .then(() => {
            let newTab = this.getInitialTab(this.recognition.overview);
            if (newTab) {
              this.tab = newTab;
            }
            this.getList();
          });
      });
    }
  }
};
</script>
